// Base spinner component
import React from 'react';

import { Spinner } from 'baseui/spinner';

const BaseSpinner = () => <Spinner size={90} color={'#E028DD'} />;

// Fixed centered spinner
const FixedSpinner = () => (
  <div
    className="
      fixed left-1/2 top-1/2
      -translate-x-1/2 -translate-y-1/2
    "
  >
    <BaseSpinner />
  </div>
);

export const SpinnerComponent = (props: {
  loading?: boolean;
  positionRelative?: boolean;
}): JSX.Element | null => {
  if (props.loading) {
    return props.positionRelative ? <BaseSpinner /> : <FixedSpinner />;
  } else {
    return null;
  }
};
